var _style, _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPptx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 64",
    style: {
      enableBackground: "new 0 0 49 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000137830463751924268550000011777117811872107418_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#C43E1C;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FF8F6B;}\n\t.st3{fill:#F9F7F7;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 49,
    height: 64
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007425807591456557120000011791576263723710640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000007425807591456557120000011791576263723710640_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,16.8v42.1c0,2.8-2.3,5.1-5.1,5.1H5.1C2.3,64,0,61.7,0,58.9V5.1C0,2.3,2.3,0,5.1,0h27L49,16.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49,15.9V18H35.2c-2.9,0-4.2-2.3-4.2-5.2V0h2.1L49,15.9z"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.7,34.8c1.1-0.1,2.1,0.2,3,0.9c0.7,0.6,1.1,1.6,1,2.6c0,0.6-0.2,1.2-0.5,1.7c-0.4,0.6-0.9,1-1.5,1.3 c-0.7,0.3-1.5,0.5-2.2,0.5h-2.1v4h-2.1v-11L24.7,34.8z M22.4,39.9h1.8c0.6,0,1.2-0.1,1.6-0.5c0.4-0.2,0.6-0.7,0.6-1.1 c0-1.2-0.7-1.8-2.1-1.8h-1.9L22.4,39.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.7c54d743166675c9af57083bf776e413.svg";
export { ForwardRef as ReactComponent };